export enum SURVEY_QUESTION_TYPE {
    CHECKBOX = 'CHECKBOX',
    RADIO = 'RADIO',
}

export enum SURVEY_ANSWER_TYPE {
    BASIC = 'BASIC',
    OPTIONAL_TEXT = 'OPTIONAL_TEXT',
}
